const ChannelBuckets = {
  ACTIVE: 'ACTIVE',
  DRAFT: 'DRAFT',
  ARCHIVED: 'ARCHIVED',
  AI_FRIEND: 'AI_FRIEND',
  ALL: 'ALL',
};

const channelBucketsConfig = {
  [ChannelBuckets.ACTIVE]: {
    label: 'Active',
  },
  [ChannelBuckets.DRAFT]: {
    label: 'Draft',
  },
  [ChannelBuckets.ARCHIVED]: {
    label: 'Archived',
  },
  [ChannelBuckets.AI_FRIEND]: {
    label: 'AI Friend',
  },
  [ChannelBuckets.ALL]: {
    label: 'All',
  },
};

export {
  ChannelBuckets,
  channelBucketsConfig,
};
